import {
  BrowserRouter,
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom";

import React, {useMemo} from 'react';

import { Link, PrimaryButton, Stack, TextField } from '@fluentui/react';

import Team from './pages/Team.js';
import CreateMemberForm from "./components/CreateMemberForm.js";
import SignInForm from "./components/SignInForm.js";
import TokenValidationWrapper from "./components/TokenValidatorWrapper.js";
import ResetPassword from "./components/ResetPassword.js";
import People from "./pages/People.js";
import CompassProjects from './pages/CompassProjects.js';
import ClientsManager from "./pages/Clients.js";
import ProposalsManager from "./pages/ProposalManager.js";
import ProjectDashboard from "./pages/ProjectDashboard.js";
import ProposalDashboard from "./pages/ProposalDashboard.js";
import PeopleDashboard from "./pages/PeopleDashboard.js";
import NewProposalPage from "./pages/NewProposal.js";
import AppNavBar from "./components/AppNavBar.js";
import ClientDashboard from "./pages/ClientDashboard.js";
import EditPerson from "./pages/EditPeople.js";
import EditProject from "./pages/EditProject.js";
import ProposalEditPage from "./pages/EditProposal.js";
import CreatePoject from "./pages/CreateProject.js";
import AiToolsRoutes from "./pages/AiToolRoutes.js";
import axios from "axios";

const HIDE_NAV = [
  '/',
  '/sign-in',
  '/create-account',
  '/reset-password',
  '/request-reset-password'
];

function Layout({ children }) {
  const { pathname } = useLocation();

  const showNav = useMemo(() => {
    for (const rule of HIDE_NAV) {
      if (typeof rule === 'string' && rule === pathname) return false;
      if (rule instanceof RegExp && rule.test(pathname)) return false;
    }
    return true;
  }, [pathname]);

  return (
    <>
      {showNav && <AppNavBar />}
      {children}
    </>
  );
}


function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/request-reset-password" component={RequestResetPassword} />
          <Route exact path="/sign-in" component={SignIn}  />
          <Route exact path="/create-account" component={CreateAccount} />
          <Route exact path="/reset-password" component={ResetPassword} />
          <Route path="/planner" component={Planner} />
          <Route path="/ai" component={AiToolsRoutes} />
          <Route path="/people/bio-builder" component={() => <Redirect to="/ai" />} />
          <Route path="/people/:personId/edit" component={EditPerson} />
          <Route path="/people/:personId" component={PeopleDash} />
          <Route path="/people" component={Ppl} />
          <Route path="/projects/create" component={CreatePoject} />
          <Route path="/projects/:projectId/edit" component={EditProject} />
          <Route path="/projects/:projectId" component={ProjDash} />
          <Route path="/projects" component={CompProj} />
          <Route path="/clients/:clientId" component={ClientDashboard} />
          <Route path="/clients" component={Cli} />
          <Route path="/proposals/create" component={CreateProposal} />
          <Route path="/proposals/:proposalId/edit" component={ProposalEditPage} />
          <Route path="/proposals/:proposalId" component={PropDash} />
          <Route path="/proposals" component={Prop} />
        </Switch>
      </Layout>
    </BrowserRouter>
  );
}

export default App;

const PeopleDash = (p) => <TokenValidationWrapper><PeopleDashboard {...p} /></TokenValidationWrapper>
const Ppl = (p) => <TokenValidationWrapper><People {...p} /></TokenValidationWrapper>
const ProjDash = (p) => <TokenValidationWrapper><ProjectDashboard {...p} /></TokenValidationWrapper>
const CompProj = (p) => <TokenValidationWrapper><CompassProjects {...p} /></TokenValidationWrapper>
const Cli = (p) => <TokenValidationWrapper><ClientsManager {...p} /></TokenValidationWrapper>
const CreateProposal = (p) => <TokenValidationWrapper><NewProposalPage {...p} /></TokenValidationWrapper>
const PropDash = (p) => <TokenValidationWrapper><ProposalDashboard {...p} /></TokenValidationWrapper>
const Prop = (p) => <TokenValidationWrapper><ProposalsManager {...p} /></TokenValidationWrapper>


const Planner = () => {
  return <TokenValidationWrapper>
    <Team />
  </TokenValidationWrapper>
}

const SignIn = (props) => {
  return <SignInForm successCallback={() => props.history.push('/planner')}>
    <Link onClick={() => props.history.push('/create-account')}>Need an account? Sign up</Link>
  </SignInForm>
}

const CreateAccount = (props) => {
  <CreateMemberForm>
    <Link onClick={() => props.history.push('/sign-in')}>Already a member? Sign in</Link>
  </CreateMemberForm>
}

const Home = (props) => {
  const [route, setRoute] = React.useState('sign-in');
  return <div>
    {
      route === 'create' ? <CreateMemberForm>
        <Link onClick={() => setRoute('sign-in')}>Already a member? Sign in</Link> : 
      </CreateMemberForm> : <SignInForm successCallback={() => props.history.push('/planner')}>
        <Link onClick={() => setRoute('create')}>Need an account? Sign up</Link>
      </SignInForm>
    }
  </div>
}


const RequestResetPassword = (props) => {

  const [email, setEmail] = React.useState("");

  const requestPasswordReset = () => {
    axios.post('/api/request-reset-password', {email})
     .then(response => {
      console.log(response);
      alert("Please contact Clayton for you password reset code.")
     })
     .catch(err => {
      alert("Unable to process request");
     })
  }

  return <Stack tokens={{childrenGap: 16}} styles={{root: {maxWidth: 400, margin: '64px auto'}}}>
    <h3>Request Password Reset</h3>
    <TextField label="Email" value={email} onChange={(e, v) => setEmail(v)} />
    <PrimaryButton disabled={!email} text="Submit" onClick={requestPasswordReset} />
  </Stack>
}